import { render, staticRenderFns } from "./Q_Removal.vue?vue&type=template&id=1b517ff1"
import script from "./Q_Removal.vue?vue&type=script&lang=js"
export * from "./Q_Removal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports